module.exports = __webpack_public_path__ + "img/ico-share-trial-desktop.2cbc82db.svg";